import React, { createContext, useContext, useMemo } from 'react';

import { type TTemplate } from '@wp-block-builder/package';

type TState = {
  configuration: TTemplate;
  layoutConfiguration: TTemplate | null;
};

const Context = createContext<TState | null>(null);
type TProps = {
  children: JSX.Element;
  configuration: TTemplate;
  layoutConfiguration: TTemplate | null;
};

export function Provider({ children, configuration, layoutConfiguration }: TProps) {
  const value = useMemo<TState>(
    () => ({
      configuration,
      layoutConfiguration,
    }),
    [configuration, layoutConfiguration]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useDocumentStoreContext() {
  return useContext(Context)!;
}

export function useStrictVariablesRendering() {
  return useContext(Context)!.configuration.strictVariablesRendering;
}
